import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Activity, ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import AOS from 'aos';
import 'aos/dist/aos.css';

const MarathonTraining = () => {
  useEffect(() => {
    AOS.init({ duration: 600, easing: 'ease-in-out', once: true });
  }, []);

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="container">
          <div className="service-hero-content" data-aos="fade-up">
            <Activity size={64} className="service-hero-icon" />
            <h1 className="display-large">Marathon Training</h1>
            <p className="body-large">
              Comprehensive endurance training programs for runners of all levels, from your 
              first 5K to marathon distance.
            </p>
            <Link to="/contact">
              <Button className="btn-cta">Book Free Consultation<ArrowRight className="ml-2" size={20} /></Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="service-content-section">
        <div className="container">
          <div className="service-content-grid">
            <div className="service-image-large" data-aos="fade-right">
              <img src="https://images.pexels.com/photos/2803158/pexels-photo-2803158.jpeg" alt="Marathon Training" />
            </div>
            <div className="service-details" data-aos="fade-left">
              <h2 className="heading-1">Run Your Best Race</h2>
              <p className="body-medium">
                Having trained for marathons myself, I know the dedication required. Whether 
                you're aiming for your first 5K or tackling a full marathon, I'll create a 
                structured plan that builds your endurance while preventing injury.
              </p>
              <div className="benefits-section">
                <h3 className="heading-2">Program Includes:</h3>
                <div className="benefits-list-detailed">
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Structured Training Plans</h4>
                      <p className="body-small">Periodized programming with progressive mileage buildup</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Running Form Analysis</h4>
                      <p className="body-small">Video analysis and corrections for efficient running mechanics</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Injury Prevention</h4>
                      <p className="body-small">Strength training and mobility work to keep you healthy</p>
                    </div>
                  </div>
                  <div className="benefit-item">
                    <CheckCircle className="benefit-icon" size={24} />
                    <div>
                      <h4 className="heading-3">Race Day Strategy</h4>
                      <p className="body-small">Pacing, nutrition, and mental preparation for race success</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta-section">
        <div className="container">
          <div className="service-cta-content" data-aos="fade-up">
            <h2 className="display-medium">Ready to Start Running?</h2>
            <p className="body-large">Let's create a training plan that gets you to the finish line.</p>
            <div className="service-cta-buttons">
              <Link to="/contact">
                <Button className="btn-cta">Book Free Consultation<ArrowRight className="ml-2" size={20} /></Button>
              </Link>
              <Link to="/services"><Button className="btn-secondary">View All Services</Button></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MarathonTraining;
